import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../lib/cn.js';

/**
 * Código de 6 dígitos num único campo: colar funciona, preenchimento automático do SO funciona
 * (autocomplete=one-time-code) e leitores de tela leem como um campo só (docs/04 §6.7).
 */
export const OtpInput = forwardRef<HTMLInputElement, Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> & {
  invalid?: boolean; onValueChange?: (v: string) => void; length?: number;
}>(({ className, invalid, onValueChange, length = 6, ...props }, ref) => (
  <input
    ref={ref}
    inputMode="numeric"
    autoComplete="one-time-code"
    pattern={`\\d{${length}}`}
    maxLength={length}
    aria-invalid={invalid || undefined}
    onChange={(e) => onValueChange?.(e.target.value.replace(/\D/g, '').slice(0, length))}
    className={cn(
      'h-14 w-full rounded-md border border-border-strong bg-surface text-center font-mono text-2xl font-semibold',
      'tracking-[0.5em] indent-[0.5em] text-fg tabular-nums placeholder:text-fg-subtle placeholder:tracking-[0.5em]',
      'focus:border-primary aria-invalid:border-danger',
      className,
    )}
    placeholder={'•'.repeat(length)}
    {...props}
  />
));
OtpInput.displayName = 'OtpInput';
